import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaDownload, FaPlay, FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SEO } from '../../components/SEO';
import { FaCheckCircle, FaBuilding, FaChartLine, FaFileContract, FaGavel, FaClipboardCheck, FaRegFileAlt, FaFileAlt, FaBriefcase } from 'react-icons/fa';
import BrandText from '../../styles/brandStyles';

const Dependencias = () => {
  const { translate } = useLanguage();
  const [activeSection, setActiveSection] = useState('overview');
  const [isSticky, setIsSticky] = useState(false);
  
  // Estados para controlar los carruseles
  const [activeCard1, setActiveCard1] = useState(0);
  const [activeCard2, setActiveCard2] = useState(0);
  const [activeCard3, setActiveCard3] = useState(0);

  // Datos para los carruseles
  const carouselData1 = [
    {
      image: "/images/modules/opus_m4/001 BASE DE DATOS DE LICITACIONES.png",
      title: "Gestión automatizada de licitaciones",
      description: "Implementa una base de datos centralizada de licitaciones que integra toda la información necesaria para el seguimiento y control de los procesos de contratación pública.",
      features: [
        "Formatos estandarizados para licitaciones",
        "Generación automática de documentos",
        "Sin recaptura de información"
      ],
      link: "/caracteristicas/licitaciones"
    },
    {
      image: "/images/modules/opus_m4/002 Entrega de propuestas de licitantes.png",
      title: "Formatos personalizables para concursos",
      description: "Facilita la entrega de propuestas de licitantes mediante formatos estandarizados y personalizables que agilizan el proceso de recepción y evaluación de ofertas.",
      features: [
        "Plantillas predefinidas para distintos tipos de concursos",
        "Integración de catálogos de conceptos",
        "Generación automática de documentación"
      ],
      link: "/caracteristicas/bases-concurso"
    },
    {
      image: "/images/modules/opus_m4/003 Comunicación bidireccional.png",
      title: "Evaluación integral de propuestas",
      description: "Establece una comunicación bidireccional entre dependencias y licitantes que optimiza el flujo de información y facilita la evaluación de propuestas técnicas y económicas.",
      features: [
        "Sin recaptura de información",
        "Comunicación fluida entre dependencia y licitantes",
        "Mayor eficiencia en procesos"
      ],
      link: "/caracteristicas/evaluacion-propuestas"
    }
  ];

  const carouselData2 = [
    {
      image: "/images/modules/opus_m4/004 Elaboración de presupuesto base.png",
      title: "Presupuesto base optimizado",
      description: "Elabora presupuestos base de manera eficiente para incluirlos en las bases de licitación, con integración directa a los módulos de presupuestación y programación de OPUS.",
      features: [
        "Integración con OPUS Presupuesto Programable",
        "Generación automática de presupuesto base",
        "Formato Excel para bases de licitación"
      ],
      link: "/caracteristicas/normatividad"
    },
    {
      image: "/images/modules/opus_m4/005 Integración de las bases de la licitación.png",
      title: "Bases de licitación completas",
      description: "Integra documentación completa para las bases de licitación, incluyendo anexos técnicos, legales y económicos en formatos estandarizados y compatibles con sistemas gubernamentales.",
      features: [
        "Compatibilidad con Compranet",
        "Paquete completo de bases de licitación",
        "Planos, documentos y plantillas incluidas"
      ],
      link: "/caracteristicas/bitacora"
    },
    {
      image: "/images/modules/opus_m4/006 Recepción de propuestas de los licitantes .png",
      title: "Administración integral de propuestas",
      description: "Gestiona eficientemente la recepción de propuestas de los licitantes, facilitando la organización, revisión y evaluación de toda la documentación recibida.",
      features: [
        "Descarga sencilla de propuestas en formato zip",
        "Planos, cartas y presupuestos en un solo lugar",
        "Formatos estandarizados para fácil evaluación"
      ],
      link: "/caracteristicas/transparencia"
    }
  ];

  const carouselData3 = [
    {
      image: "/images/modules/opus_m4/007 COMPARATIVO.png",
      title: "Análisis comparativo automatizado",
      description: "Genera cuadros comparativos detallados para evaluar las propuestas recibidas, identificando condiciones favorables, precios unitarios y ofertas más convenientes.",
      features: [
        "Análisis comparativo automático",
        "Configuración personalizada de criterios",
        "Identificación de ofertas más competitivas"
      ],
      link: "/caracteristicas/contratos-publicos"
    },
    {
      image: "/images/modules/opus_m4/006 Recepción de propuestas de los licitantes .png",
      title: "Selección transparente de propuestas",
      description: "Implementa un proceso transparente para la recepción y evaluación de propuestas, asegurando objetividad y cumplimiento normativo en la adjudicación de contratos.",
      features: [
        "Evaluación objetiva de propuestas",
        "Registro sistemático del proceso de selección",
        "Transparencia en la adjudicación"
      ],
      link: "/caracteristicas/estimaciones-pagos"
    },
    {
      image: "/images/modules/opus_m4/005 Integración de las bases de la licitación.png",
      title: "Software gratuito para licitantes",
      description: "Proporciona a los licitantes una herramienta gratuita para acceder y responder a las bases de licitación, facilitando la integración completa de su documentación.",
      features: [
        "Software gratuito para licitantes",
        "Recepción de bases en formato zip",
        "Compatible con OPUS Evaluador de Propuestas"
      ],
      link: "/caracteristicas/finiquitos"
    }
  ];

  // Función para manejar el scroll y actualizar la sección activa
  useEffect(() => {
    const handleScroll = () => {
      // Detectar si el submenú debe ser sticky
      const heroSection = document.getElementById('overview');
      const headerHeight = 64; // Altura del header principal
      
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsSticky(heroBottom <= headerHeight);
      } else {
        // Si no se encuentra la sección, mantener el menú sticky para evitar que desaparezca
        setIsSticky(true);
      }

      // Detectar qué sección está visible
      const sections = ['overview', 'features', 'capabilities', 'benefits', 'cta'];
      let activeFound = false;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offset = 140; // Altura del header + submenu
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(section);
            activeFound = true;
            break;
          }
        }
      }
      
      // Si no se encuentra ninguna sección activa, mantener la última activa
      if (!activeFound && window.scrollY > 0) {
        // Mantener la sección activa anterior o establecer una por defecto
        setIsSticky(true);
      }
    };

    // Ejecutar handleScroll inmediatamente para establecer el estado inicial
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Función para hacer scroll a una sección
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 140; // Altura del header + submenu
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Funciones para navegar entre las tarjetas
  const nextCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard + 1) % maxCards);
  };

  const prevCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard - 1 + maxCards) % maxCards);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="OPUS - Módulo 4: Dependencias | ECOSOFT"
        description="Solución especializada para organismos gubernamentales y dependencias que requieren cumplir con normativas específicas en proyectos de obra pública."
        keywords="OPUS, obra pública, gobierno, dependencias, licitaciones, normativa"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[450px] bg-gradient-to-r from-[#003171] to-[#0066CC]" style={{
        backgroundImage: 'url("/images/modules/opus_m4/opusm4.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <div className="flex items-center mb-6">
              <div className="relative w-32 h-32 mr-6 flex-shrink-0">
                <div className="absolute inset-[5%] bg-white rounded-full"></div>
                <img 
                  src="/images/m4.svg" 
                  alt="Módulo 4" 
                  className="w-full h-full relative z-10"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h1 className="text-5xl font-bold">OPUS M4</h1>
                <h2 className="text-4xl font-bold mt-2">Dependencias</h2>
              </div>
            </div>
            <p className="text-xl mb-8">
              Automatización del proceso de Licitación. Apegado a los criterios de la Ley de Obras Públicas.
            </p>
            <div className="flex gap-4">
              <Link to="/soporte/descargas" className="bg-white text-[#0066CC] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors">
                Descargar
              </Link>
              <Link to="/Distribuidores" className="border-2 border-white text-white px-8 py-3 rounded-md font-semibold hover:bg-white/10 transition-colors">
                Ver demostración
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Submenu Navigation */}
      <div 
        className={`bg-white shadow-md transition-all duration-300 sticky-nav ${
          isSticky 
            ? 'fixed top-[64px] left-0 right-0 z-30 border-t border-gray-200' 
            : 'relative'
        }`}
        style={{ minHeight: '56px' }} // Altura mínima para evitar saltos
      >
        <div className="container mx-auto px-4 max-w-7xl\">
          <div className="flex overflow-x-auto py-4 items-center relative">
            <div className="flex-grow flex">
              <button 
                onClick={() => scrollToSection('overview')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'overview' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Resumen
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'features' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Características
              </button>
              <button 
                onClick={() => scrollToSection('capabilities')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'capabilities' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Capacidades
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'benefits' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Beneficios
              </button>
              <button 
                onClick={() => scrollToSection('cta')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'cta' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Comenzar
              </button>
            </div>
            <div className="flex items-center ml-4">
              <img 
                src="/images/m4.svg" 
                alt="Módulo 4 - Dependencias" 
                className="h-12 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Features Section */}
      <section id="features" className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Características principales</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaFileContract className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Licitaciones y concursos</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Formatos estandarizados para licitaciones</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Evaluación técnica y económica de propuestas</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Comparativos y dictámenes de fallo</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Control de documentación legal y técnica</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Gestión de bases de concursos</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaBuilding className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Normatividad de obra pública</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Cumplimiento con normativas federales y estatales</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Formatos oficiales preestablecidos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Bitácora electrónica de obra pública</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Reportes para órganos de fiscalización</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Administración de anticipos y garantías</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaChartLine className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Control de avance y estimaciones</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Registro de avances físicos y financieros</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Generación de estimaciones según normativa</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Control de aditivas, deductivas y extraordinarios</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Seguimiento de fechas de pago</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Finiquitos y cierre administrativo</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section id="capabilities" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-3">Lo que puedes hacer con OPUS M4</h2>
          <p className="text-xl text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            Descubre cómo OPUS M4 te ayuda a gestionar proyectos de obra pública con total apego a la normatividad vigente.
          </p>
          
          <div className="space-y-12">
            {/* Capability 1 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData1[activeCard1].image} 
                  alt={carouselData1[activeCard1].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData1[activeCard1].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData1[activeCard1].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData1[activeCard1].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 2 */}
            <div className="flex flex-col md:flex-row-reverse gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData2[activeCard2].image} 
                  alt={carouselData2[activeCard2].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData2[activeCard2].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData2[activeCard2].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData2[activeCard2].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 3 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData3[activeCard3].image} 
                  alt={carouselData3[activeCard3].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData3[activeCard3].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData3[activeCard3].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData3[activeCard3].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section id="benefits" className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Beneficios para el sector público</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaGavel className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Transparencia</h3>
              <p className="text-gray-600">
                Permite la supervisión detallada y la rendición de cuentas en cada etapa del proceso de obra pública.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaClipboardCheck className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Cumplimiento normativo</h3>
              <p className="text-gray-600">
                Asegura que todos los procesos y documentación cumplan con las leyes y reglamentos vigentes.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaRegFileAlt className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Eficiencia administrativa</h3>
              <p className="text-gray-600">
                Reduce los tiempos de gestión administrativa y minimiza errores en procesos críticos.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaChartLine className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Control presupuestal</h3>
              <p className="text-gray-600">
                Maximiza el aprovechamiento de los recursos públicos y previene desviaciones presupuestales.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Integration with other modules */}
      <section className="py-16 bg-[#F5F7FA]">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Integración con otros módulos</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            El Módulo 4 se integra perfectamente con el resto de OPUS para ofrecer una solución completa para el sector gubernamental
          </p>
          
          <div className="grid md:grid-cols-5 gap-6 max-w-5xl mx-auto">
            <Link to="/modulos/presupuesto-programable" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 1</h3>
              <p className="text-gray-600 text-sm">Presupuesto Programable</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/planeacion-control" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 2</h3>
              <p className="text-gray-600 text-sm">Planeación y Control</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/administracion-compras" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 3</h3>
              <p className="text-gray-600 text-sm">Administración de Compras</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/dependencias" className="bg-[#F5F7FA] p-5 rounded-lg text-center border-2 border-[#0066CC] hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 4</h3>
              <p className="text-gray-600 text-sm">Dependencias</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/cuantificacion-bim" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 5</h3>
              <p className="text-gray-600 text-sm">Cuantificación BIM</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Cursos y CERTIFICADOS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Cursos y Certificados</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Fortalece tus conocimientos en OPUS Dependencias con nuestro programa de certificación
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaGavel className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso básico</h3>
              <p className="text-gray-600 mb-4 text-center">
                Aprende los fundamentos para gestionar licitaciones públicas
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaFileAlt className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso avanzado</h3>
              <p className="text-gray-600 mb-4 text-center">
                Domina técnicas avanzadas de licitación y presupuestación para dependencias
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaBriefcase className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Certificación oficial</h3>
              <p className="text-gray-600 mb-4 text-center">
                Obtén la certificación oficial ECOSOFT que valida tus conocimientos profesionales
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section id="cta" className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para optimizar tus procesos de licitación pública?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Descubre el potencial de OPUS M4 Dependencias para la gestión eficiente de proyectos y licitaciones gubernamentales.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/soporte/descargas" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Descargar
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Solicitar demostración
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 bg-white text-[#1A2B39] hover:bg-gray-100 font-medium rounded-md transition-colors"
            >
              Contactar con ventas
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dependencias; 
